import {
    Selector,
    createSelector,
} from 'reselect';
import { initialState } from './reducer';
import { RootState } from '@vfde-sails/core';
import { IAuthentication } from './interfaces/main.interface';
import { NAMESPACE } from './constant';

const selectState = (state: RootState<IAuthentication>): IAuthentication => state[NAMESPACE] || initialState;

const selectMtanStep = (): Selector<RootState<IAuthentication>, IAuthentication['mtanStep']> =>
    createSelector(selectState, state => state.mtanStep);

const selectLoading = (): Selector<RootState<IAuthentication>, IAuthentication['loading']> =>
    createSelector(selectState, state => state.loading);

const selectError = (): Selector<RootState<IAuthentication>, IAuthentication['error']> =>
    createSelector(selectState, state => state.error);

const selectIsUserLoggedIn = (): Selector<RootState<IAuthentication>, IAuthentication['isUserLoggedIn']> =>
    createSelector(selectState, state => state.isUserLoggedIn);

const selectComponents = (): Selector<RootState<IAuthentication>, IAuthentication['components']> =>
    createSelector(selectState, state => state.components);

export {
    selectState,
    selectLoading,
    selectError,
    selectMtanStep,
    selectIsUserLoggedIn,
    selectComponents,
};
